const TipeSurat = {
    PERPANJANGAN: 'Perpanjangan',
    PENAMBAHAN_KENDARAAN: 'Penambahan Unit Kendaraan',
    PENAMBAHAN_JENIS_B3: 'Penambahan Jenis B3',
    BARU: 'Permohonan Baru',
};
  
export default TipeSurat;